module.exports = __webpack_public_path__ + "static/media/esim_graph1_chz.85d316c9.png";